import _defineProperty from "/home/runner/work/ui/ui/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/es6.string.starts-with.js";
import "core-js/modules/es6.array.slice.js";
var KitCategory = {
  TCR: 'tcr',
  BCR: 'bcr',
  WT: 'wt',
  fromKit: function fromKit(kit) {
    // Using startsWith instead of explicitly checking is a bit brittle so be careful with kit names
    if (isKitCategory(kit, KitCategory.TCR)) {
      return KitCategory.TCR;
    }
    if (isKitCategory(kit, KitCategory.BCR)) {
      return KitCategory.BCR;
    }
    if (isKitCategory(kit, KitCategory.WT)) {
      return KitCategory.WT;
    }
    throw new Error("Unknown kit: ".concat(kit));
  }
};

// MAX WT kits are named after their product line (e.g. max_wt_l), so the prefix
// needs to be stripped before matching against a category.
var normalizeKit = function normalizeKit(kit) {
  var lowerCaseKit = kit.toLowerCase();
  return lowerCaseKit.startsWith('max_') ? lowerCaseKit.slice(4) : lowerCaseKit;
};
var isKitCategory = function isKitCategory(kit, categoryInput) {
  if (!kit) return false;
  var normalizedKit = normalizeKit(kit);
  var categories = Array.isArray(categoryInput) ? categoryInput : [categoryInput];
  return categories.some(function (category) {
    return normalizedKit.startsWith(category);
  });
};
var isMaxWtKit = function isMaxWtKit(kit) {
  return Boolean(kit) && kit.toLowerCase().startsWith('max_wt');
};
var immuneDbOptionsByKitCategory = _defineProperty(_defineProperty(_defineProperty({}, KitCategory.BCR, ['human', 'mouse', 'transgenic_mouse']), KitCategory.TCR, ['human', 'mouse']), KitCategory.WT, []);
export default KitCategory;
export { isKitCategory, isMaxWtKit, immuneDbOptionsByKitCategory };